<script setup>
import {ref, computed, watch, onMounted} from "vue";
import axios from "axios";
import {Pagination, Select, SelectOption} from "ant-design-vue";
import moment from "moment";
import ImageService from "@/services/ImageService";
import ImageRender from "@/components/Base/ImageRender.vue";
import BaseChoiseSelect from "@/components/Base/BaseChoiseSelect.vue";

moment.locale('ru');

let competitions = ref([]);

let current = ref(1);
let currentActive = ref(1);
let currentComplete = ref(1);
let pageSize = ref(12);

let type = ref('');

const page = ref(null);

const competitionStatusFilter = ref('Все конкурсы');
const search = ref('');

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  current.value = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1
})


const paginatedCompetitions = computed(() => {
  const start = (current.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return competitionsFiltered.value.slice(start, end);
})

const competitionsFiltered = computed(() => {
  let filteredCompetitions = competitions.value;

  if (type.value && type.value.length > 0) {
    filteredCompetitions = filteredCompetitions.filter((competition) => {
      return competition.napravlenie === type.value;
    });
  }

  if (search.value && search.value.length > 0) {
    filteredCompetitions = filteredCompetitions.filter((competition) => {
	    return competition.name && competition.name.toLowerCase().includes(search.value.toLowerCase());
    });
  }

  return filteredCompetitions;
})


const completedCompetitions = computed(() => {
  return competitionsFiltered.value.filter((competition) => {
    return moment(competition.endDate).startOf('day').isBefore(moment().startOf('day'));
  });
})

const paginatedCompleteCompetitions = computed(() => {
  const start = (currentComplete.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return completedCompetitions.value.slice(start, end);
})

const activeCompetitions = computed(() => {
  return competitionsFiltered.value.filter((competition) => {

    return moment(competition.endDate).startOf('day').isSameOrAfter(moment().startOf('day'));
    //return moment(competition.endDate).isSameOrAfter(moment());
  });
})

const paginatedActiveCompetitions = computed(() => {
  const start = (currentActive.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return activeCompetitions.value.slice(start, end);
})


async function getCompetitions() {
  const response = await axios.get('/competition/get_competitions');
  competitions.value = response.data;
}

getCompetitions();

function formatDate(date) {
  return moment(date).format('D MMMM YYYY');
}

function truncateText(text, maxLength) {
  if (text !== null && text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  } else {
    return text;
  }
}

function get_uploaded_image_asset(path) {
  return ImageService.getCompetitionImagePath(path);
}


function onImageError() {
  console.log('333');
}

watch(() => current.value, (newValue, oldValue) => {
  let url = new URL(window.location.href);
  url.searchParams.set('page', newValue);
  window.history.pushState({}, '', url);
})

</script>

<template>
  <div>
    <h1>Конкурсы</h1>
	  
	  <div class="filter_top_block">
      <BaseChoiseSelect
          v-model="competitionStatusFilter"
          :values="[{label: 'Все конкурсы', value: 'Все конкурсы'}, {label: 'Активные', value: 'Активные'}, {label: 'Завершенные', value: 'Завершенные'}]"
      />

      <div class="field">
        <label>Тип конкурса</label>
        <Select
            v-model:value="type"
            size="middle"
            style="width: 300px"
            :allowClear="true"
        >
          <SelectOption value="Сценарный конкурс">Сценарный конкурс</SelectOption>
          <SelectOption value="Кинофестиваль">Кинофестиваль</SelectOption>
          <SelectOption value="Конкурс стартапов">Конкурс стартапов</SelectOption>
          <SelectOption value="Конкурс проектов">Конкурс проектов</SelectOption>
        </Select>
      </div>

      <div class="search_field_wrapper">
        <div class="control">
          <input name="search_textfield" class="input search_textfield"
                 type="text"
                 placeholder="Найти конкурс" v-model="search" />
        </div>
        <div class="control">
          <input value="Поиск" type="submit" class="button search_button is-info">
        </div>
      </div>

      
	  </div>
	  
	  <template v-if="competitionStatusFilter === 'Все конкурсы' || competitionStatusFilter === 'Активные'">
      <div class="podpunkt">Активные конкурсы</div>
      <div class="columns is-multiline competitions_columns">
        <div v-for="(competition, index) in paginatedActiveCompetitions" :key="competition.id"
             class="column competition__wrapper" :class="index % 2 === 0 ? 'col2' : 'col1'">
          <div class="competition_wrapper_inside">
            <div class="competition_wrapper_inner" style="position: relative">
              <div class="competition_header">
                <p class="competition-type" v-if="competition.competitionData?.is_bussines_area == 'true'">
                  Бизнес-площадка</p>
                <p class="competition-type" v-else>{{ competition.napravlenie }}</p>
                <div class="competition_do">
                  <div class="competition_do_inner">
                    <span class="priem">ПРИЕМ ЗАЯВОК</span>
                    <span class="date_to">До {{ formatDate(competition.endDate) }}</span>
                  </div>
                </div>
              </div>
              <div class="competition_wrapper_inner" style="position: relative">
                <div class="competition-image-wrapper">
                  <a class="competition-title" :href="'/competition/single/'+competition.id">
                    <ImageRender
                        :src="get_uploaded_image_asset(competition.avatar)"
                        class-name="competition_image"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Pagination
		      v-if="activeCompetitions.length > 12"
          :current="currentActive"
          :pageSize="pageSize"
          :total="activeCompetitions.length"
          @change="(page)=>{currentActive = page;}"
      ></Pagination>
	  </template>

    <template v-if="competitionStatusFilter === 'Все конкурсы' || competitionStatusFilter === 'Завершенные'">
      <div class="podpunkt">Завершенные конкурсы</div>
      <div class="columns is-multiline competitions_columns">
        <div v-for="(competition, index) in paginatedCompleteCompetitions" :key="competition.id"
             class="column competition__wrapper completed" :class="index % 2 === 0 ? 'col2' : 'col1'">
          <div class="competition_wrapper_inside">
            <div class="competition_wrapper_inner" style="position: relative">
              <div class="competition_header">
                <p class="competition-type" v-if="competition.competitionData?.is_bussines_area == 'true'">
                  Бизнес-площадка</p>
                <p class="competition-type" v-else>{{ competition.napravlenie }}</p>
                <div class="competition_do">
                  <div class="competition_do_inner">
                    <span class="priem">ПРИЕМ ЗАЯВОК</span>
                    <span class="date_to">ЗАВЕРШЕН</span>
                  </div>
                </div>
              </div>
              <div class="competition_wrapper_inner" style="position: relative">
                <div class="competition-image-wrapper">
                  <a class="competition-title" :href="'/competition/single/'+competition.id">
                    <ImageRender
                        :src="get_uploaded_image_asset(competition.avatar)"
                        class-name="competition_image"
                    ></ImageRender>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Pagination
          :current="currentComplete"
          :pageSize="pageSize"
          :total="completedCompetitions.length"
          @change="(page)=>{currentComplete = page;}"
      ></Pagination>
    </template>
	  
  </div>
</template>



<style scoped>
.first-block .container .content h1 {
    margin-bottom: 40px;
}

.filter_top_block {
		display: flex;
		justify-content: space-between;
    margin-bottom: 40px;
}

.filter_top_block:deep .field_description__wrapper {
		display: none;
}

.competition_wrapper_inside {
    background: #f7f7f7;
    border-radius: 24px;
		max-width: none;
}
.competition_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.competition_wrapper_inside .competition_wrapper_inner {
	padding: 10px;
}

.filter_top_block:deep .choise_item {
		padding: 15px;
}

.filter_top_block:deep .choise_wrapper {
		height: 40px;
}

.filter_top_block:deep .search_field_wrapper .control .search_textfield, .filter_top_block:deep .control .search_button {
		height: 40px;
}


.filter_top_block:deep .field {
    display: flex;
    margin-bottom: 0;
    margin-top: 0;
		align-items: center;
}
.filter_top_block:deep .field label {
    margin-right: 10px;
    margin-bottom: 0;
}

.filter_top_block:deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {height: 40px !important;}

.competitions_columns .column {
    width: 49%;
		flex-basis: 49%;
		max-width: 49%;
}
.competition-image-wrapper:deep img {
    border-radius: 20px;
}

.competition-title {
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
}

.competition_do {
    color: #1E2329;
    border-radius: 50px;
    font-weight: 400;
    font-size: 20px;
}

.competition_do_inner {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: Play, sans-serif;
}
.competition_do_inner .priem {
    font-family: "Onest", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 115%;
    text-transform: uppercase;
    margin-bottom: 5px;
    text-align: right;
    color: rgba(62, 78, 104, 0.4);
}

.competition_do_inner .date_to {
    font-family: "Onest", sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 115%;
    text-transform: uppercase;
    text-align: right;
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


.content .competition-type {
    font-family: "Onest", sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 115%;
    text-transform: uppercase;
    color: #1d232d;
}

.competition-title__wrapper {
    flex-grow: 1;
}

.competiton_order_button_div {
    margin-top: 35px;
    font-family: Play, sans-serif;
}

.competiton_order_button {
    color: #EE9D46;
    font-weight: 400;
}

.competiton_order_button i {
    margin-left: 10px;
}

.competition_image {
    width: 100%;
    margin-bottom: -1px;
}
.competition_wrapper_inside:deep img.competition_image {
    max-height: none;
}
.podpunkt {
    font-family: "Onest", sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #1d232d;
    margin-bottom: 30px;
}

.content p:not(:last-child) {
    margin-bottom: auto;
}

.info_block p {
    margin-bottom: 10px;
}

.describe_text {
    color: #1E2329;
    font-weight: 400;
    font-size: 24px;
    font-family: 'Play';
}



.number_circles_block .column {
    position: relative;
}

.line {
    border-top: 5px solid #EDECEC;
    width: 84%;
    position: absolute;
    left: 79px;
    top: 43px;
}

.footer {
    background: #fff;
}

.filter_button__wrapper {
    position: relative;
}

.filter_button_title {
    font-weight: 400;
    font-size: 20px;
    color: #1E2329;
    margin-bottom: 25px;
    font-family: 'Play';
}

.filter_button_window {
    background: #FFFDFD;
    box-shadow: 0px 7px 41px -8px rgba(30, 35, 41, 0.3);
    border-radius: 17px;
    padding: 30px 20px;
    max-width: 345px;
    position: absolute;
    top: 49px;
    z-index: 11;
    left: 0;
    display: none;
}

.competition__wrapper.completed:deep img {filter: grayscale(100%);}

.competition__wrapper.completed:deep .date_to {
		background: rgba(29, 35, 45, 0.7);
		background-clip: text;
}

@media (max-width: 1450px) {
    .number_circle {
        width: 55px;
        height: 55px;
    }

    .number_circle_text {
        font-size: 20px;
    }

    .number_circles_block {
        margin-top: 55px;
    }

    .line {
        left: 69px;
        top: 38px;
    }

    .number_circle_text {
        margin-top: 25px;
    }

    body > header {
        padding-bottom: 50px;
    }

    .competition_wrapper {
        max-width: 360px;
    }

    .competition_do {
        font-size: 17px;
    }

    .competition_wrapper {
        padding: 20px;
    }

    .competition_do_circle {
        width: 10px;
        height: 10px;
        margin-right: 14px;
    }

    .competition-title {
        font-size: 17px;
    }
}


@media (max-width: 1220px) {
    .competition_wrapper {
        max-width: 295px;
    }
}

@media (min-width: 1024px) {
    .column.is-5-desktop {
        width: 48%;
    }
}
@media (max-width: 1000px) {
		.filter_top_block {
				flex-direction: column;
		}
    .filter_top_block:deep .choise_wrapper {
				flex-direction: column;
		    height: auto;
		    width: 100%;
        margin-bottom: 10px;
		}
    .filter_top_block:deep .field {
        margin-bottom: 20px;
    }
    .competitions_columns .column {
        width: 100%;
        flex-basis: 100%;
		    max-width: none;
    }
    .content .competition-type {
        font-size: 14px;
    }
    .competition_do_inner .date_to {
        font-size: 16px;
    }
    .competition_do_inner .priem {
        font-size: 12px;
    }
    .line {
        display: none;
    }

    .section {
        padding: 0 15px;
    }

    .number_circle_text {
        font-size: 20px;
    }

    .describe_text {
        font-size: 20px;
    }

    .number_circles_block {
        margin-top: 30px;
    }

    .number_circle {
        width: 45px;
        height: 45px;
        font-size: 25px;
    }

    .competition_wrapper {
        padding: 10px;
        max-width: 48%;
        flex-basis: auto;
        min-width: 168px;
        border-radius: 15px;
        margin-top: 0;
    }

    .competitions_columns {
        margin-top: 30px;
    }

    .competition_do_inner {
        font-size: 11px;
    }

    .competition_do_circle {
        margin-right: 5px;
        margin-bottom: 0;
        width: 7px;
        height: 7px;
    }

    .competition-image-wrapper:deep img {
        border-radius: 12px;
    }

    .competition-info {
        padding: 0;
    }

    .competition-type {
        font-size: 12px;
    }

    .competition-title__wrapper {
        line-height: 1;
    }

    .competition-title {
        font-size: 13px;
    }

    .competiton_order_button {
        font-size: 13px;
    }

    .competiton_order_button_div {
        margin-top: 10px;
    }
}

@media (max-width: 370px) {
    .competition_wrapper {
        max-width: 100%;
    }
}
</style>